import { createContext, useContext } from "react";
import invariant from "tiny-invariant";
import type { ScriptModule } from "virtual:script";

export type ScriptContextValue = {
  script: ScriptModule;
  language: ScriptLang;
  setLanguagePickerVariant: (variant: "subtle" | "labeled") => void;
};

export const scriptContext = createContext<ScriptContextValue | null>(null);

export function useScript() {
  const context = useContext(scriptContext);
  invariant(context, "`useScript` must be used within a `ScriptProvider`");
  return context;
}
